import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';

class FacebookRedirect extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired
  };

  componentDidMount() {
    const {history} = this.props;

    history.replace({
      pathname: localStorage.getItem('@mobiuspace.campaigns.redirectUri')
    });

    localStorage.removeItem('@mobiuspace.campaigns.redirectUri');
  }

  render() {
    return null;
  }
}

export default class Auth extends Component {
  render() {
    return (
      <Switch>
        <Route path="/auth/redirects/facebook" component={FacebookRedirect} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Auth/index.js